import { tv } from '@joyful/utils'

export const markdownVariants = tv({
  base: null,

  defaultVariants: {
    inset: 'none',
    leading: 'normal',
    size: 'md',
    tone: 'strong',
  },

  slots: {
    code: 'bg-tremor-background-subtle text-tremor-content-emphasis overscroll-x-none rounded-xs px-1 font-mono border',
    em: 'italic',
    hr: 'bg-tremor-border h-1 border-none bg-clip-content',
    li: 'marker:text-tremor-content-emphasis mb-1 last:mb-0',
    mention:
      '[&_a]:no-underline [&_a]:after:absolute [&_a]:after:inset-0 [&_a]:after:content-[""] [&>span]:static [&>span]:truncate [&>span:not(.inline-flex)]:inline',
    ol: 'list-decimal p-0 mt-0 mb-4',
    p: 'mt-0 tracking-normal',
    root: '[&>*:first-child]:mt-0 [&>*:last-child]:mb-0',
    strong: 'font-bold',
    table: 'my-0! w-full border-collapse',
    td: 'border-b border-tremor-border text-tremor-content-emphasis',
    th: 'border-b border-tremor-border text-left font-semibold text-tremor-content-strong',
    ul: 'mt-0 mb-4 list-disc p-0',
  },

  variants: {
    inset: {
      none: {
        root: null,
      },
      rule: {
        root: 'border-l-2 pl-2',
      },
    },

    leading: {
      normal: {
        code: 'leading-normal',
        li: 'leading-normal',
        mention: 'leading-normal',
        p: 'leading-normal',
        root: 'leading-normal',
        td: 'leading-normal',
        th: 'leading-normal',
      },
      relaxed: {
        code: 'leading-relaxed',
        li: 'leading-relaxed',
        mention: 'leading-relaxed',
        p: 'leading-relaxed',
        root: 'leading-relaxed',
        td: 'leading-relaxed',
        th: 'leading-relaxed',
      },
    },

    size: {
      lg: {
        code: 'text-base',
        hr: 'my-6!',
        li: 'ml-6 text-base',
        mention: 'text-base md:text-base',
        p: 'text-base mb-4',
        td: 'px-3 py-2 text-base',
        th: 'px-3 py-2 text-base',
      },

      md: {
        code: 'text-sm',
        hr: 'my-6!',
        li: 'ml-6 text-sm',
        mention: 'text-sm md:text-sm',
        p: 'text-sm mb-4',
        td: 'px-3 py-2 text-sm',
        th: 'px-3 py-2 text-sm',
      },

      sm: {
        code: 'text-[0.8rem]',
        hr: 'my-5!',
        li: 'ml-4 text-[0.8rem]',
        mention: 'text-[0.8rem] md:text-[0.8rem]',
        p: 'text-[0.8rem] mb-2.5',
        td: 'px-2 py-1.5 text-[0.8rem]',
        th: 'px-2 py-1.5 text-[0.8rem]',
      },

      xl: {
        code: 'text-lg',
        hr: 'my-6!',
        li: 'ml-6 text-lg',
        mention: 'text-lg md:text-lg',
        p: 'text-lg mb-4',
        td: 'px-3 py-2 text-lg',
        th: 'px-3 py-2 text-lg',
      },

      xs: {
        code: 'text-xs',
        hr: 'my-5!',
        li: 'ml-4 text-xs',
        mention: 'text-xs md:text-xs',
        p: 'text-xs mb-2.5',
        td: 'px-2 py-1.5 text-xs',
        th: 'px-2 py-1.5 text-xs',
      },
    },

    tone: {
      content: {
        root: 'text-tremor-content',
      },
      emphasis: {
        root: 'text-tremor-content-emphasis',
      },
      strong: {
        root: 'text-tremor-content-strong',
      },
      subtle: {
        root: 'text-tremor-content-subtle',
      },
    },
  },
})
